<template>
<b-col cols="12" class="marginaltop">
    <b-row class="justify-content-around align-items-center">
        <b-col cols="5" sm="4" md="3">
            <b-img fluid-grow :src="require('@/assets/logo_Q_Analytics.svg')">
                <h2>Plug-In</h2>
            </b-img>
        </b-col>
    </b-row>
            <vue-markdown style="overflow: auto" class="marginaltop">
# How to get the analytics for a specific video

## Step 1: Define a custom **videoID** in the configuration of your player 

When initializing the Quanteec Player, you must pass a configuration. In this configuration, you can pass a **videoID** string. This **videoID** is used to identify the video in the analytics.

``` javascript
// Example of a simple configuration object

var configuration = {
    videoID: "videoID", // [Mandatory] String --> ID of the video. Provided by the client to identify the video. Used by the analytics and the P2P system to identify a video.
    clientID: 'clientID', // [Mandatory] String --> Provided by Quanteec. ID of the client using the player. Used to verify the authorizations.
};
```

## Step 2: Open the analytics for your video

In the Analytics page of your Quanteec account, you can: 

1) replace the input form **Video ID** by your custom **videoID**,

2) click on the refresh button on the right
    </vue-markdown>
    <b-row class="justify-content-around align-items-center">
        <b-col cols="12" sm="10" md="8">
            <b-img fluid-grow :src="require('@/assets/Analytics/screenAnalyticsCustom.png')">
            </b-img>
        </b-col>
    </b-row>
</b-col>
</template>
<script>
import VueMarkdown from 'vue-markdown';
import Prism from 'prismjs';
import 'prismjs/themes/prism-twilight.css';
export default {
  name: 'VisualizationTool',
  data: function() {
    return {
     
    }
  },
  components: {
      VueMarkdown
  },
  mounted: function() {

    this.$nextTick(() => {
        Prism.highlightAll()
      });  
  },
  methods: {
     
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>